import cloneDeep from 'lodash/cloneDeep';
import defaultsDeep from 'lodash/defaultsDeep';

/**
 * Lodash defaultsDeep mutates the original objects.
 * This helper runes defaultsDeep on deep copies of the object to preserve the original objects.
 */
const defaultsDeepClone = (obj1: unknown, obj2: unknown) => {
  return defaultsDeep(cloneDeep(obj1), cloneDeep(obj2));
};

export default defaultsDeepClone;
